import React, { useEffect, useState } from 'react';
import MonitoringPage from './MonitoringPage'; // если файл UI отдельно
import api from '@/lib/api';

const MonitoringPageContainer = () => {
    const [monitoringSubTab, setMonitoringSubTab] = useState('campaigns');
    const [campaignFilterStatus, setCampaignFilterStatus] = useState('all');
    const [campaignFilterScenario, setCampaignFilterScenario] = useState('all');
    const [contactFilterOrganization, setContactFilterOrganization] = useState('all');
    const [contactFilterStatus, setContactFilterStatus] = useState('all');

    const [campaigns, setCampaigns] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [scenarios, setScenarios] = useState([]);
    const [organizations, setOrganizations] = useState([]);

    useEffect(() => {
        api.get('/api/campaigns/monitoring/campaigns/')
            .then(res => setCampaigns(res.data))
            .catch(err => console.error('Failed to load campaigns:', err));

        api.get('/api/campaigns/monitoring/contacts/')
            .then(res => {
                const mapped = (res.data || []).map(c => ({
                    ...c,
                    type: 'reply', // чтобы фильтр по "reply" сработал
                    content: c.lastReplyText || '', // чтобы "Content" заполнился
                    timestamp: c.lastReplyAt || c.lastInteraction, // для форматирования даты
                    replied: (c.status || '').toLowerCase() === 'replied',
                    read: false // если захочешь отслеживать прочтения
                }));

                setContacts(mapped);

                const orgs = [...new Set(mapped.map(c => c.organizationName).filter(Boolean))]
                    .map(name => ({ id: name, name }));
                setOrganizations(orgs);
            })
            .catch(err => console.error('Failed to load contacts:', err));

        api.get('/api/campaigns/scenarios/')
            .then(res => {
                if (Array.isArray(res.data)) {
                    setScenarios(res.data); // [{value: ..., label: ...}]
                } else {
                    console.error('Scenarios response is not an array:', res.data);
                }
            })
            .catch(err => console.error('Failed to load scenarios:', err));
    }, []);


    const filteredMonitoringCampaigns = campaigns.filter((c) => {
        const matchesStatus =
            campaignFilterStatus === 'all' ||
            String(c.status).toLowerCase() === String(campaignFilterStatus).toLowerCase();

        const matchesScenario =
            campaignFilterScenario === 'all' ||
            String(c.scenario) === String(campaignFilterScenario);

        return matchesStatus && matchesScenario;
    });

    const filteredMonitoringContacts = contacts.filter(c => {
        const matchesOrg = contactFilterOrganization === 'all' || c.organizationName === contactFilterOrganization;
        const matchesStatus =
            contactFilterStatus === 'all' ||
            (c.status || 'N/A').toLowerCase() === contactFilterStatus.toLowerCase();
        return matchesOrg && matchesStatus;
    });

    // const contactInteractions = contacts.flatMap(c => ({
    //     contactId: c.id,
    //     type: c.status === 'replied' ? 'reply' : c.status === 'opened' ? 'opened' : '',
    //     timestamp: c.lastInteraction,
    //     status: c.status
    // })).filter(i => i.type);

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return 'N/A';
        const date = new Date(timestamp);
        return date.toLocaleString();
    };

    return (
        <MonitoringPage
            monitoringSubTab={monitoringSubTab}
            setMonitoringSubTab={setMonitoringSubTab}
            campaignFilterStatus={campaignFilterStatus}
            setCampaignFilterStatus={setCampaignFilterStatus}
            campaignFilterScenario={campaignFilterScenario}
            setCampaignFilterScenario={setCampaignFilterScenario}
            contactFilterOrganization={contactFilterOrganization}
            setContactFilterOrganization={setContactFilterOrganization}
            contactFilterStatus={contactFilterStatus}
            setContactFilterStatus={setContactFilterStatus}
            filteredMonitoringCampaigns={filteredMonitoringCampaigns}
            scenarios={scenarios}
            organizations={organizations}
            filteredMonitoringContacts={filteredMonitoringContacts}
            formatTimestamp={formatTimestamp}
        />
    );
};

export default MonitoringPageContainer;